// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EarthquakeStatus } from './earthquake-status';


export class EarthquakeStatusMessage implements flatbuffers.IUnpackableObject<EarthquakeStatusMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EarthquakeStatusMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEarthquakeStatusMessage(bb:flatbuffers.ByteBuffer, obj?:EarthquakeStatusMessage):EarthquakeStatusMessage {
  return (obj || new EarthquakeStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEarthquakeStatusMessage(bb:flatbuffers.ByteBuffer, obj?:EarthquakeStatusMessage):EarthquakeStatusMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EarthquakeStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():EarthquakeStatus {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : EarthquakeStatus.Off;
}

static startEarthquakeStatusMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:EarthquakeStatus) {
  builder.addFieldInt16(0, message, EarthquakeStatus.Off);
}

static endEarthquakeStatusMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEarthquakeStatusMessage(builder:flatbuffers.Builder, message:EarthquakeStatus):flatbuffers.Offset {
  EarthquakeStatusMessage.startEarthquakeStatusMessage(builder);
  EarthquakeStatusMessage.addMessage(builder, message);
  return EarthquakeStatusMessage.endEarthquakeStatusMessage(builder);
}

unpack(): EarthquakeStatusMessageT {
  return new EarthquakeStatusMessageT(
    this.message()
  );
}


unpackTo(_o: EarthquakeStatusMessageT): void {
  _o.message = this.message();
}



unpackFields(...fields: string[]): EarthquakeStatusMessageT {
  const t = new EarthquakeStatusMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('message')) {
    t.message = this.message();
  }
  return t;
}
}

export class EarthquakeStatusMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: EarthquakeStatus = EarthquakeStatus.Off
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return EarthquakeStatusMessage.createEarthquakeStatusMessage(builder,
    this.message
  );
}

clone(): EarthquakeStatusMessageT {
  const obj = new EarthquakeStatusMessageT();
  obj.message = this.message;
  return obj;
}

equals(other: EarthquakeStatusMessageT): boolean {
  if (this.message !== other.message) return false;
  return true;
}
}

export function verifyEarthquakeStatusMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
